export default class UTMParams {
  static readonly campaign: string = 'utm_campaign';
  static readonly content: string = 'utm_content';
  static readonly medium: string = 'utm_medium';
  static readonly source: string = 'utm_source';;
  static readonly term: string = 'utm_term';
}
